import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';

import { driverDepositOrderMakeReturn, driverDepositInstantInvoiceOrder } from  "../../actions/deposit_driver";
import { rd } from "../../../../utils";
import { stateToCenterId } from "../../../../utils/center";
import "../../css/Deposit.css";

const DepositOrderDriverReturn = ({
  driver,
  deposit_driver,
  centers,
  currentCenterId,
  dispatch
}) => {
  const { orders } = deposit_driver;
  // Vérifier si la fonctionnalité est activée pour ce centre
  const currentCenter = centers.find(c => c.id === currentCenterId);
  const isDynamicBillingEnabled = currentCenter && currentCenter.dynamic_consigne_billing_enabled === true;

  // États pour les modals
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [submittingInvoice, setSubmittingInvoice] = useState(false);
  const [invoiceReason, setInvoiceReason] = useState("");
  const [invoicingOrderId, setInvoicingOrderId] = useState(null);

  const handleInvoiceClick = (order) => {
    setSelectedOrder(order);
    setInvoiceReason("");
    setShowInvoiceModal(true);
  };

  const confirmInvoice = async () => {
    if (selectedOrder && !submittingInvoice) {
      setSubmittingInvoice(true);
      setInvoicingOrderId(selectedOrder.order_id);
      setShowInvoiceModal(false);

      try {
        await dispatch(driverDepositInstantInvoiceOrder(driver.id, selectedOrder.order_id, currentCenterId, invoiceReason));
        // Succès : réinitialiser l'état
        setSubmittingInvoice(false);
        setInvoicingOrderId(null);
        setSelectedOrder(null);
        setInvoiceReason("");
      } catch (error) {
        // Erreur : réinitialiser l'état pour permettre de réessayer
        setSubmittingInvoice(false);
        setInvoicingOrderId(null);
      }
    }
  };

  return orders.length > 0
    ? (
      <div className="DepositDriverReturn">
        <div>
          {orders.map(depositOrder => (
            <div key={depositOrder.order_id} className="DepositOrderRow">
              <Link to={`/support/order/${depositOrder.order_id}/`} target="_blank" rel="noopener noreferrer">
                Commande <strong>#{depositOrder.random_id}</strong>
              </Link>
              <p>{rd(depositOrder.amount)} €</p>
              <div style={{ display: 'flex', gap: '5px' }}>
                <Button
                  variant="primary"
                  size="sm"
                  onClick={
                    () => dispatch(driverDepositOrderMakeReturn(driver.id, depositOrder.order_id))
                  }
                >
                  Retourner
                </Button>
                {isDynamicBillingEnabled && (
                  <>
                    <Button
                      variant="warning"
                      size="sm"
                      onClick={() => handleInvoiceClick(depositOrder)}
                      disabled={invoicingOrderId === depositOrder.order_id}
                    >
                      {invoicingOrderId === depositOrder.order_id ? 'Facturation...' : 'Facturer'}
                    </Button>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Note: unlock UI removed — unblocking is handled at the driver level now */}

        {/* Modal facturation */}
        <Modal show={showInvoiceModal} onHide={() => setShowInvoiceModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Facturer une commande</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedOrder && (
              <>
                <p>
                  <strong>Commande :</strong> #{selectedOrder.random_id}
                </p>
                <div className="alert alert-warning">
                  <strong>Montant à facturer :</strong> {rd(selectedOrder.amount)}€
                </div>
                <p className="text-muted">
                  Cette commande sera facturée sur la facture mensuelle du livreur.
                </p>
                <div className="form-group">
                  <label htmlFor="invoiceReason">Raison de la facturation (optionnel)</label>
                  <textarea
                    id="invoiceReason"
                    className="form-control"
                    rows="3"
                    value={invoiceReason}
                    onChange={(e) => setInvoiceReason(e.target.value)}
                    placeholder="Ex: Commande non retournée, matériel perdu..."
                    disabled={submittingInvoice}
                  />
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setShowInvoiceModal(false)} disabled={submittingInvoice}>Annuler</Button>
            <Button bsStyle="warning" onClick={confirmInvoice} className="btn-warning pull-right" disabled={submittingInvoice}>
              {submittingInvoice ? 'Facturation en cours...' : 'Confirmer la facturation'}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    ) : (
      <div>
        <br />
        <p className="alert alert-info">
          Le livreur n&apos;a pas de commande consignée en sa possession
        </p>
      </div>
    );
};

DepositOrderDriverReturn.propTypes = {
  driver: PropTypes.object.isRequired,
  deposit_driver: PropTypes.object.isRequired,
  centers: PropTypes.array.isRequired,
  currentCenterId: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect(
  state => ({
    deposit_driver: state.dispatch.deposit.driver,
    centers: state.dispatch.metas.centers || [],
    currentCenterId: stateToCenterId(state),
  })
)(DepositOrderDriverReturn);
